"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-pin.tsx
var Pin = function Pin(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M8 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3V3.382C16.9999 3.56766 16.9481 3.74963 16.8504 3.90753C16.7528 4.06542 16.6131 4.19301 16.447 4.276L15 5V10L17.707 12.707C17.8946 12.8945 17.9999 13.1488 18 13.414V15C18 15.2652 17.8946 15.5196 17.7071 15.7071C17.5196 15.8946 17.2652 16 17 16H13V20L12 23L11 20V16H7C6.73478 16 6.48043 15.8946 6.29289 15.7071C6.10536 15.5196 6 15.2652 6 15V13.414C6.00006 13.1488 6.10545 12.8945 6.293 12.707L9 10V5L7.553 4.276C7.38692 4.19301 7.24722 4.06542 7.14955 3.90753C7.05188 3.74963 7.0001 3.56766 7 3.382V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2Z",
    fill: "currentColor"
  }));
};

var _default = Pin;
exports.default = _default;